import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-text-list',
  templateUrl: './text-list.component.html',
  styleUrls: ['./text-list.component.scss']
})
export class TextListComponent implements OnInit, OnChanges {

  @Input() block: any;
  @Input() resetValue: boolean = false;
  @Input() firstInput: any;
  @Input() lastInput: any;
  @Output() onSelected = new EventEmitter();;
  public options: any = [];
  public valueSelected = '';
  public viewContainer: boolean = false;

  constructor(
    public helpersService: HelpersService,
    private elementRef: ElementRef,
  ) { }

  ngOnInit(): void {
    this.options = [];
    if (this.block.filter_type === 'vocabulary') {
      for (const opt of this.block.value) {
        this.options.push({ id: opt.term_id, name: opt.name })
      }
    }
    if (this.block.filter_type === 'textList') {
      for (const opt of Object.keys(this.block.select_options.values)) {
        this.options.push({ id: opt, name: this.block.select_options.values[opt] })
      }

    }
    this.setValueFromBlock();
  }

  private setValueFromBlock(): void {
    if (!this.block || !this.block.value_sel) {
      return;
    }
    let selected = this.block.value_sel[this.block.filter_name];
    if (selected instanceof Array) {
      selected = selected[0];
    }
    if (selected === undefined || selected === null || selected === '') {
      return;
    }
    const found = this.options.find((opt: any) => opt.name === selected || String(opt.id) === String(selected));
    this.valueSelected = found ? found.name : selected;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetValue']) {
      if (changes['resetValue'].currentValue) {
        this.valueSelected = '';
      }
    }
  }

  selectVal(opt: string) {
    this.valueSelected = opt;
    const ret: any = {};
    ret[this.block.filter_name] = opt;
    this.onSelected.emit(ret);
  }

  @HostListener('document:click', ['$event'])
  closeSelect(event: any) {
    const clicked = this.elementRef.nativeElement.contains(event.target);
    if (!clicked || event.target.classList.contains('custom-select__option')) {
      this.viewContainer = false;
    }
  }


}
